import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true,
        },
    ],
})
export class ToggleSwitchComponent implements ControlValueAccessor {
    checked = false;
    disabled = false;

    private onChange = (_: any) => {};
    private onTouched = () => {};

    writeValue(value: any): void {
        this.checked = value === 1 || value === true;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    toggle(event: Event) {
        if (this.disabled) return;

        const target = event.target as HTMLInputElement;
        this.checked = target.checked;
        this.onChange(this.checked ? 1 : 0);
        this.onTouched();
    }
}
